import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../utils/api';

const IMG_BASE = process.env.REACT_APP_IMG_URL || 'http://localhost:5000';

export default function AdminDepartmentForm() {
  const { id }   = useParams();
  const navigate = useNavigate();
  const isEdit   = Boolean(id);

  const [form, setForm] = useState({ name: '', description: '', sort_order: 0, is_active: true });
  const [imageFile, setImageFile]   = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);

  useEffect(() => {
    if (!isEdit) { setLoading(false); return; }
    api.get('/admin/departments')
      .then(res => {
        const dept = res.data.find(d => String(d.id) === id);
        if (!dept) { toast.error('Departamenti nuk u gjet.'); return; }
        setForm({
          name:        dept.name        || '',
          description: dept.description || '',
          sort_order:  dept.sort_order  || 0,
          is_active:   dept.is_active === 1 || dept.is_active === true,
        });
        if (dept.image) setImagePreview(`${IMG_BASE}${dept.image}`);
      })
      .catch(() => toast.error('Gabim gjatë ngarkimit.'))
      .finally(() => setLoading(false));
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error('Emri është i detyrueshëm.');
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append('name',        form.name);
      fd.append('description', form.description || '');
      fd.append('sort_order',  form.sort_order  || 0);
      fd.append('is_active',   form.is_active ? '1' : '0'); // explicit '1'/'0'
      if (imageFile) fd.append('image', imageFile);

      if (isEdit) {
        await api.put(`/admin/departments/${id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        toast.success('Departamenti u përditësua.');
      } else {
        await api.post('/admin/departments', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        toast.success('Departamenti u krijua.');
      }
      navigate('/admin/departamentet');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Gabim.');
    } finally { setSaving(false); }
  };

  if (loading) return <AdminLayout><div className="spinner"/></AdminLayout>;

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <h1 className="page-title">{isEdit ? 'Ndrysho Departamentin' : 'Departament i Ri'}</h1>
        <Link to="/admin/departamentet" className="btn btn-secondary">← Kthehu</Link>
      </div>

      <form onSubmit={handleSubmit} style={{display:'grid',gridTemplateColumns:'1fr 300px',gap:'1.25rem',alignItems:'start'}}>
        <div className="card" style={{padding:'1.5rem'}}>
          <div className="form-group">
            <label className="form-label">Emri i departamentit *</label>
            <input className="form-input" required value={form.name}
              onChange={e => setForm(p => ({...p, name: e.target.value}))}/>
          </div>
          <div className="form-group">
            <label className="form-label">Përshkrimi</label>
            <textarea className="form-input" rows={4} value={form.description}
              onChange={e => setForm(p => ({...p, description: e.target.value}))}/>
          </div>
        </div>

        <div>
          <div className="card" style={{padding:'1.25rem', marginBottom:'1rem'}}>
            <h3 className="form-side-title">Foto</h3>
            {imagePreview && (
              <img src={imagePreview} alt="" style={{width:'100%', height:140, objectFit:'cover', borderRadius:8, marginBottom:10}}/>
            )}
            <input type="file" accept="image/*" className="form-input"
              onChange={e => {
                const f = e.target.files[0];
                setImageFile(f);
                if (f) setImagePreview(URL.createObjectURL(f));
              }}/>
          </div>

          <div className="card" style={{padding:'1.25rem', marginBottom:'1rem'}}>
            <h3 className="form-side-title">Renditja</h3>
            <input className="form-input" type="number" min="0" value={form.sort_order}
              onChange={e => setForm(p => ({...p, sort_order: Number(e.target.value)}))}/>
          </div>

          <div className="card" style={{padding:'1.25rem', marginBottom:'1rem'}}>
            <h3 className="form-side-title">Statusi</h3>
            <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:'0.875rem',fontWeight:500}}>
              <input type="checkbox"
                checked={form.is_active}
                onChange={e => setForm(p => ({...p, is_active: e.target.checked}))}/>
              Aktiv (i dukshëm)
            </label>
          </div>

          <button type="submit" className="btn btn-primary"
            style={{width:'100%', justifyContent:'center'}} disabled={saving}>
            {saving ? 'Duke ruajtur...' : isEdit ? 'Ruaj ndryshimet' : 'Krijo departamentin'}
          </button>
        </div>
      </form>
    </AdminLayout>
  );
}
